
import {Component, Mixins, Emit, Watch} from 'vue-property-decorator';
import {MDB} from '@/plugins/uyap-plugin/MDB';
import {IbanTercihiEnum} from '@/plugins/uyap-plugin/uyap/IbanTercihiEnum';
import {DosyaFormDataInterface} from '@/plugins/uyap-plugin/takip_ac/DosyaFormDataInterface';
import TakipHazirlaOptions from '@/components/forms/form-wizard/eicrapro/takip-hazirla/TakipHazirlaOptions.vue';
import XmlUploadInput from '@/components/forms/form-wizard/eicrapro/shared/XmlUploadInput.vue';
import ObjectInputMixin from '@/mixins/ObjectInputMixin.vue';
import TamamlanmayanTakipList from "@/components/eicrapro/TamamlanmayanTakipList.vue";

type XmlKaynak = 'dosya' | 'liste';

@Component({
  components: {
    TamamlanmayanTakipList,
    TakipHazirlaOptions,
    XmlUploadInput,
  },
})
export default class TakipBilgileriForm extends Mixins(ObjectInputMixin) {
  // ObjectInputMixin'den gelen tipler
  localValue!: DosyaFormDataInterface & { xml?: File | null };
  input!: (value?: any, isChangeData?: boolean) => void;

  // Refs
  $refs!: {
    form: any;
  };

  // Local state
  mdb = new MDB();
  xmlValidationError: string | null = null;
  xmlKaynak: XmlKaynak = 'dosya';

  // Enums
  IbanTercihiEnum = IbanTercihiEnum;

  // Options
  kotaKullanimSekliItems = [
    {text: 'Avukat', value: '0'},
    {text: 'Kurum', value: '1'},
    {text: 'Takip Tipleri', value: '2'}
  ];

  ibanTercihiItems = [
    {text: 'Avukat', value: IbanTercihiEnum.Avukat},
    {text: 'Müvekkil', value: IbanTercihiEnum.Muvekkil},
  ];

  fileRule = (file: File | null) => {
    if (!file) return true;
    const isXml = file.name.toLowerCase().endsWith('.xml');
    return isXml || 'Sadece XML dosyası yükleyebilirsiniz';
  };

  // Computed properties - Vuex getters
  get adliyeler(): any[] {
    return this.$store.getters['takipHazirla/adliyeler'] || [];
  }

  get avukatIbanlari(): any[] {
    return this.$store.getters['takipHazirla/avukatIbanlari'] || [];
  }

  get showXmlUploadZone(): boolean {
    return this.xmlKaynak === 'dosya'
        || (this.xmlKaynak === 'liste' && !!this.localValue.xml);
  }

  secXmlKaynak(kaynak: 'dosya' | 'liste') {
    if (this.xmlKaynak === kaynak) {
      return;
    }
    this.xmlKaynak = kaynak;
    this.$set(this.localValue, 'xml', null);
    this.xmlValidationError = null;
    this.input();
  }

  // Lifecycle
  async mounted() {
    // IBAN tercihi default olarak Avukat ise IBAN'ları yükle
    if (this.localValue.ibanTercihi === IbanTercihiEnum.Avukat) {
      await this.loadAvukatIbanlari();
    }
  }

  // Watchers - Store entegrasyonu
  @Watch('localValue.il')
  async onIlChange(newIl: string, oldIl: string) {
    if (newIl !== oldIl) {
      // Adliye seçimini temizle
      this.$set(this.localValue, 'adliye', null);
      // Yeni il için adliyeleri yükle
      if (newIl) {
        await this.$store.dispatch('takipHazirla/fetchAdliyeler', newIl);
      }
      this.input();
    }
  }

  @Watch('localValue.ibanTercihi')
  async onIbanTercihiChange(newTercih: IbanTercihiEnum, oldTercih: IbanTercihiEnum) {
    if (newTercih !== oldTercih) {
      // IBAN tercihi değiştiğinde avukat IBAN'ını temizle
      if (newTercih !== IbanTercihiEnum.Avukat) {
        this.localValue.avukatIban = '';
      } else {
        // IBAN tercihi Avukat ise IBAN listesini yükle
        await this.loadAvukatIbanlari();
      }
      this.input();
    }
  }

  // Event handlers (emitInput kaldırıldı - ObjectInputMixin.input() kullanılıyor)

  async loadAvukatIbanlari() {
    try {
      const response = await this.$uyap.AvukatKayitliIbanList().run({});
      const ibanlari = response.value || [];
      this.$store.commit('takipHazirla/SET_AVUKAT_IBANLARI', ibanlari);
      // İlk IBAN'ı varsayılan olarak seç
      if (ibanlari.length > 0 && !this.localValue.avukatIban) {
        this.localValue.avukatIban = ibanlari[0].ibanNumarasi;
        this.input();
      }
    } catch (error) {
      console.error('Avukat İBAN\'ları yüklenirken hata:', error);
    }
  }


  handleXmlFileSelected(file: File | null) {
    // Local value'yu güncelle (reactive - ObjectInputMixin sayesinde)
    this.$set(this.localValue, 'xml', file);

    // Parent'ı güncelle
    this.input();
    this.$emit('xml-selected', file);
  }

  @Emit('validation-error')
  handleXmlValidationError(message: string | null) {
    if (typeof message === 'string' && message.length) {
      this.xmlValidationError = message;
    } else {
      this.xmlValidationError = null;
    }
    return message;
  }


  // Public method for parent to validate form
  public validate(): boolean {
    if (!this.$refs.form) {
      return false;
    }
    return this.$refs.form.validate();
  }
}
